<template>
  <div class="trust-and-safety mx-auto px-16 mb-72">
    <h2 class="text-h2">Focused on safety</h2>
    <p class="text-body mt-8">
      Our dedicated team is working hard behind the scenes every day. For more information about our commitment to safety, visit
      our
      <a class="underline text-grey-clickable" href="https://www.sittercity.com/trust-and-safety"
        >Trust&nbsp;and&nbsp;Safety&nbsp;Center</a
      >.
    </p>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-16 py-16 mt-24 mb-32">
      <div class="mx-auto">
        <BackgroundCheckShieldIcon aria-hidden="true" class="mx-auto" />
        <h4 class="text-strong-body lg:text-h4 text-center mt-24">Run background checks</h4>
      </div>
      <div>
        <IdCardIcon aria-hidden="true" class="mx-auto" />
        <h4 class="text-strong-body lg:text-h4 text-center mt-24">Identity verification</h4>
      </div>
      <div>
        <FraudPreventionIcon aria-hidden="true" class="mx-auto mt-36 md:mt-0" />
        <h4 class="text-strong-body lg:text-h4 text-center mt-24">Fraud prevention</h4>
      </div>
      <div>
        <MagnifyingGlassIcon aria-hidden="true" class="mx-auto mt-36 md:mt-0" />
        <h4 class="text-strong-body lg:text-h4 text-center mt-24">Safety screenings</h4>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import BackgroundCheckShieldIcon from '@/icons/BackgroundCheckShieldIcon.vue';
import IdCardIcon from '@/icons/IdCardIcon.vue';
import FraudPreventionIcon from '@/icons/FraudPreventionIcon.vue';
import MagnifyingGlassIcon from '@/icons/MagnifyingGlassIcon.vue';

export default {
  name: 'TrustAndSafetySection',
  components: { BackgroundCheckShieldIcon, IdCardIcon, FraudPreventionIcon, MagnifyingGlassIcon },
};
</script>
